import Dexie, { type EntityTable } from 'dexie';

/** Training centre summary from headless session (centres linked to the user). */
export interface AuthTrainingCentre {
  id: number;
  name: string;
  /** True when the centre's accreditation level is Licensed (session payload from headless API). */
  licensed?: boolean;
}

/** User shape from django-allauth headless adapter.serialize_user (custom HeadlessAdapter). */
export interface AuthUser {
  id: number | string;
  display: string;
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  /** E.164 or string from PhoneNumberField when present. */
  phone?: string | null;
  has_usable_password?: boolean;
  username?: string;
  /** Training centres linked to the user (e.g. membership). */
  training_centres?: AuthTrainingCentre[];
  /** @deprecated Prefer `training_centres`; kept while older API responses may still send this alias. */
  organisations?: AuthTrainingCentre[];
  /** True if the user has any permissions beyond the default (e.g. from groups). */
  has_extra_permissions?: boolean;
  /** True if the user may open Wagtail CMS (matches wagtailadmin.access_admin). From headless serialize_user. */
  has_wagtail_admin_access?: boolean;
  /** True when staff/workflow has approved this account (custom User.approved). From headless serialize_user. */
  approved?: boolean;
}

/** Single row: cached session for offline use. */
export interface SessionRow {
  id: 'default';
  user: AuthUser | null;
  sessionToken: string | null;
  isAuthenticated: boolean;
  fetchedAt: number;
}

export class AuthDb extends Dexie {
  session!: EntityTable<SessionRow, 'id'>;

  constructor() {
    super('AuthDb');
    this.version(1).stores({
      session: 'id',
    });
  }
}

export const authDb = new AuthDb();
